/*!
* @alife/cn-uni-api v2.10.0
* (c) Alibaba Group Holding Limited.
*
* @license ISC
* @build at 2023/8/21 10:19:44
*/
import { WVCall } from '../../../bridges/windvane/index.js';
import { a as getRealWebUrl } from '../../../common-42e7d8d8.js';
import '../../../bridge-adpter-api-0316c034.js';
import '../../../tslib.es6-e01eabb2.js';
import '../../../safe-data-66f20265.js';
import '../../../index-6f6b9acc.js';
import '../../../_commonjsHelpers-56d33373.js';

function navigateTo(params) {
    // 驿站掌柜：https://page.cainiao.com/cn-yz/cnyz-book/_book/api/navigation.html
    WVCall('WVNavUrls.openUrl', params, {
        formatInput: function (input) {
            return { url: getRealWebUrl(input) };
        },
    });
}

export { navigateTo as default };
